export default __webpack_public_path__ + "logo-aptaclub-dach.115f681.png";